import React from 'react';
import { styled, Typography } from '@mui/material';

const StyledInlineCardContainer = styled('div')(() => ({
    display: 'flex',
    WebkitBoxPack: 'center',
    justifyContent: 'center',
    placeItems: 'center',
    borderRadius: '3px',
    cursor: 'pointer',
    flexDirection: 'column',
    WebkitBoxAlign: 'center',
    background: 'rgb(247, 246, 255, 1)',
}));

export interface IconInlineCardProps {
    Icon: React.FC<any>;
    header: string;
    description: string;
    widthInPx?: string;
    heightInPx?: string;
    onClick?: () => void;
}
export function IconInlineCard({
    Icon,
    header,
    description,
    widthInPx,
    heightInPx,
    onClick,
}: IconInlineCardProps) {
    return (
        <StyledInlineCardContainer
            style={{ width: widthInPx, height: heightInPx }}
            onClick={onClick}
        >
            <Icon
                style={{ color: '#4C17AD', marginBottom: '15px' }}
                size={'20px'}
            />
            <Typography variant="h4" margin={0}>
                {header}
            </Typography>
            <Typography variant="h5" style={{ color: '#5B5B5B' }} margin={0}>
                {description}
            </Typography>
        </StyledInlineCardContainer>
    );
}

export default IconInlineCard;
